module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    class: {
      toggled: _vm.$sidebar.showSidebar
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar1"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar2"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar3"
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "navbar-right-menu"
  }, [_c('router-link', {
    attrs: {
      "to": "account-settings"
    }
  }, [_c('div', {
    staticClass: "navbar_account navbar-right"
  }, [_c('div', {
    staticClass: "my_account navbar-right"
  }, [_c('div', {
    staticClass: "initials"
  }, [_vm._v(_vm._s(_vm.initials))])]), _vm._v(" "), _c('span', {
    staticClass: "welcome"
  }, [_vm._v("Welcome, " + _vm._s(_vm.fname))])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "open"
  }, [_c('router-link', {
    attrs: {
      "to": "support"
    }
  }, [_c('i', {
    staticClass: "ti-help-alt"
  }), _vm._v(" "), _c('p', [_vm._v("Help")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "open"
  }, [_c('router-link', {
    attrs: {
      "to": "logout"
    }
  }, [_c('i', {
    staticClass: "ti-power-off"
  }), _vm._v(" "), _c('p', [_vm._v("Logout")])])], 1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-brand"
  }, [_c('strong', [_vm._v("DeliverLogic Restaurant Portal")]), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-94e3fbf4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Layout/TopNavbar.vue
// module id = 374
// module chunks = 1